import { QueryOperation, SearchQuery } from "../../code/search-query/search-query";
import { DataColumn } from "../../controls/Data.default";
import { buildSearchQuery, comboboxValue, dateRangeValue, QueryFieldMapping } from "../../code/search-query/query-mapper";
import { Dayjs } from "dayjs";
import { InputObject } from "../../controls/default";

export interface TestGroupSearchForm {
  readonly company: InputObject;
  readonly bundle: InputObject;
  readonly createdByUserUserName: string;
  readonly createdOn: Dayjs[];
  readonly updatedByUserUserName: string;
  readonly updatedOn: Dayjs[];
}

export const testGroupsViewColumns: DataColumn[] = [
  {
    title: "Company",
    key: "companyName",
    width: 192,
    sort: true,
    defaultSort: "asc",
  },
  {
    title: "Bundle",
    key: "bundleName",
    width: 192,
    sort: true,
  },
  {
    title: "Created by",
    key: "createdByUserUserName",
    width: 192,
    sort: true,
  },
  {
    title: "Created on",
    key: "createdOn",
    width: 192,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Updated by",
    key: "updatedByUserUserName",
    width: 192,
    sort: true,
  },
  {
    title: "Updated on",
    key: "updatedOn",
    width: 192,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Allowed Submissions",
    key: "allowedSubmissions",
    width: 192,
    sort: true,
    type: "badge",
  },
  {
    title: "Users Count",
    key: "usersCount",
    width: 192,
    sort: true,
    type: "badge",
  },
];

const testGroupsQueryMappings: QueryFieldMapping[] = [
  { formField: "company", queryField: "companyUid", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "bundle", queryField: "bundleUid", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "createdByUserUserName", operation: QueryOperation.Contains },
  { formField: "createdOn", operation: QueryOperation.Between, transform: dateRangeValue },
  { formField: "updatedByUserUserName", operation: QueryOperation.Contains },
  { formField: "updatedOn", operation: QueryOperation.Between, transform: dateRangeValue },
];

export const mapTestGroupsViewQuery = (values: TestGroupSearchForm): SearchQuery =>
  buildSearchQuery(values, testGroupsQueryMappings);
